exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.my-navbar[data-v-5eb199b0] {\r\n  background-color: #249FD6;\n}\n.my-navbar .van-nav-bar__title[data-v-5eb199b0] {\r\n  color: #fff;\n}\n.my-navbar .van-nav-bar__text[data-v-5eb199b0], .my-navbar .van-nav-bar__arrow[data-v-5eb199b0] {\r\n  color: #fff;\n}\n.my-navbar .van-nav-bar__text[data-v-5eb199b0]:active {\r\n  background: transparent;\r\n  color: #e5e5e5;\n}\r\n", ""]);

// exports
